import {
    GET_SAVE_ASSET_INVENTORY,
    GET_VALIDATE_ASSET_INVENTORY_RESET,
    SET_SAVE_ASSET_INVENTORY,
    SET_VALIDATE_ASSET_INVENTORY_RESET
} from "./AssetInventoryResetTypes"

const getValidateAssetInventory = () => ({
    type: GET_VALIDATE_ASSET_INVENTORY_RESET
});

const setValidateAssetInventory = (isValidForReset: any) => ({
    type: SET_VALIDATE_ASSET_INVENTORY_RESET,
    isValidForReset: isValidForReset
})

const getSaveAssetInventoryReset = (payload?: any) => {
    return {
        type: GET_SAVE_ASSET_INVENTORY,
        payload
    }
}

const setSaveAssetInventoryReset = (isAssetInventoryRested: any) => ({
    type: SET_SAVE_ASSET_INVENTORY,
    isAssetInventoryRested: isAssetInventoryRested
})

export {
    getValidateAssetInventory,
    setValidateAssetInventory,
    getSaveAssetInventoryReset,
    setSaveAssetInventoryReset
}